import Scriba from 'react-scriba';

export class DataRepartiteur {

    static _chargementDesPerimetre_RegleLead_Comptes = (tri, recherche, nbreEnreg, pageIndex) => {
        const objet = { tri, recherche, nbreEnreg, pageIndex };
        const url = "api/Liste/ListeDesPerimetre_RegleLead_Comptes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionPerimetre_RegleLead_Compte = (idPerimetreLead) => {
        const objet = { idPerimetreLead };
        var url = "api/MAJDonnees/SuppressionPerimetreRegleLeadCompte";
        var paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementPerimetre_RegleLead_Compte = (idPerimetreLead, repartiteur, idNiveauSelectionne, items) => {
        const objet = { idPerimetreLead, repartiteur, idNiveauSelectionne, items };
        const url = "api/MAJDonnees/EnregistrementPerimetre_RegleLead_Compte";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheRepartiteur = (idPerimetreLead, idRegion, idAgence, idOperation, perimetreNational) => {
        const objet = { idPerimetreLead, idRegion, idAgence, idOperation, perimetreNational };
        const url = "api/Fiche/FicheRepartiteur";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};